import './ArtistWidget.css';
export default {
    "container": "ArtistWidget_container__pacc3",
    "title": "ArtistWidget_title__pacc3",
    "artistList": "ArtistWidget_artistList__pacc3",
    "button": "ArtistWidget_button__pacc3"
};
